import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from './Menu'
import Cookies from 'js-cookie'
import axios from '@/utils/axios'
import store from '@/store'
import { Loading } from 'element-ui'
import { log } from 'util';

Vue.use(VueRouter)

// 边栏菜单router
const bipolarInversion = () => {
  let status = store.getters.getUserApplyStatus
  let childrenRouter = []
  Menu.forEach(item => {
    if (item.children) {
      childrenRouter = [...childrenRouter, ...item.children]
    } else {
      childrenRouter.push(item)
    }
  })
  return childrenRouter
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/view/Login/index')
  },
  {
    path: '/card',
    name: 'card',
    component: () => import(/* webpackChunkName: "card" */ '@/view/GetCard/index')
  },
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '@/view/Index/index'),
    redirect: '/Management/staff',
    children: [
      ...bipolarInversion(),
      {
        path: '/certification',
        title: '认证页',
        name: 'certification',
        component: () => import(/* webpackChunkName: "certification" */ '@/view/Certification/index')
      },
      {
        path: "/Management/staff/Edit/:id",
        title: "编辑职位",
        name: "staffEditManagement",
        component: () => import(/* webpackChunkName: "staffEditManagement" */ "@/view/Management/Staff/Edit/index")
      }
    ]
  },
  // 最下面
  {
    path: '/WrongEdition',
    name: 'WrongEdition',
    component: () => import(/* webpackChunkName: "noFind" */ '@/view/WrongEdition/index')
  },
  {
    path: '/404',
    name: 'noFind',
    component: () => import(/* webpackChunkName: "noFind" */ '@/view/noFind/index')
  },
  {
    path: "*",
    redirect: "/404"
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

// 登录后部分拦截
const noCertification = (to, next) => {
  let status = store.getters.getUserApplyStatus
  let reg = /^\/Management\/staff/
  //如果方位快捷通道
  if (to.name === 'card') {
    next()
  } else if (status === 1 && reg.test(to.path)) {
    //如果账号没有完成认证,只能访问Management/staff/*页面
    next('/certification')
  } else if (status !== 3 && to.name !== 'certification') {
    next('/certification')
  } else {
    next()
  }
}

router.beforeEach((to, from, next) => {
  let token = Cookies.get('pc_token')
  const userAgent = navigator.userAgent; 
  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
 
  // 如果是ie11 及 一下 不支持
  if (isIE || isIE11) {
    if(to.name !== 'WrongEdition'){
      next('/WrongEdition')
    }else{
      next()
    }
  }else {
    if ((!token) && to.name !== 'login') {
      next("/login")
    } else if (token && to.name !== 'login') {
      if (store.getters.getUserId) {
        axios.post('/recruitment/user/userInfo').then(res => {
          store.commit('SAVA_USER_INFO', res.data)
          noCertification(to, next)
          // next()
        }).catch(() => {
        }).finally(() => {
        })
        // next()
      } else {
        let LoadContent = Loading.service({
          lock: true,
          text: '加载中'
        })
        // 跳转前请求用户数据，保证数据的最新 和 token的正确性
        axios.post('/recruitment/user/userInfo').then(res => {
          store.commit('SAVA_USER_INFO', res.data)
          noCertification(to, next)
          // next()
        }).catch(() => {
        }).finally(() => {
          LoadContent.close()
        })
      }
    } else if (token && to.name === 'login') {
      next('/')
    } else {
      next()
    }
  }
})

export default router
